import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f969e296"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createStaticVNode("<div class=\"container inner\" data-v-f969e296><div class=\"contact_details__header\" data-v-f969e296><h1 class=\"line-one\" data-v-f969e296>Work with us</h1><h2 class=\"line-two\" data-v-f969e296><a class=\"line-two\" href=\"mailto:studio@absolute.agency\" data-v-f969e296>studio@absolute.agency</a></h2><h1 class=\"line-one pt-4 mt-5\" data-v-f969e296>Talk to us</h1><h2 class=\"line-two\" data-v-f969e296>Bolton: <a href=\"tel:01204699566\" data-v-f969e296>01204 699566</a></h2><h2 class=\"line-two\" data-v-f969e296>London: <a href=\"tel:02045388086\" data-v-f969e296>020 4538 8086</a></h2></div></div>", 1);
const _hoisted_2 = [
    _hoisted_1
];
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'contact_details',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function addNoMarginClass() {
            const paragraphs = document.querySelectorAll('.contact_details__content p');
            // Find the index of the last paragraph containing an anchor link
            let lastAnchorParagraphIndex = -1;
            for (let i = paragraphs.length - 1; i >= 0; i--) {
                const children = paragraphs[i].children;
                if (children.length === 1 && children[0].tagName.toLowerCase() === 'a') {
                    lastAnchorParagraphIndex = i;
                    break;
                }
            }
            // Add the no-margin class to paragraphs containing only an <a> tag except the last one
            for (let i = 0; i < paragraphs.length; i++) {
                const children = paragraphs[i].children;
                if (children.length === 1 && children[0].tagName.toLowerCase() === 'a' && i !== lastAnchorParagraphIndex) {
                    paragraphs[i].classList.add('no-margin');
                }
            }
        }
        const ctaBanner = ref(null);
        const isScrolledIntoView = ref(false);
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 992);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 992;
        });
        // Intersection Observer setup
        onMounted(() => {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // 0.5 means when 50% of the element is visible
            };
            const callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        isScrolledIntoView.value = true;
                        observer.unobserve(entry.target);
                    }
                });
            };
            const observer = new IntersectionObserver(callback, options);
            observer.observe(ctaBanner.value);
            addNoMarginClass();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["contact_details", { 'scrolled': isScrolledIntoView.value }]),
                ref_key: "ctaBanner",
                ref: ctaBanner
            }, _hoisted_2, 2));
        };
    }
});
